// MARK://dhk8/admin-shell/lib/queries/menus
// Queries tipadas de menús — F1.7 / ADR-0009. El Admin lee menús por el grafo
// (catalog-menus), tenant del JWT (RLS). Los productos del menú se resuelven por
// la federación (MenuProduct.product → erp-products). F9.4: escrituras tambien por el grafo (mutations).
import { graphql } from '../../gql/index.js'

export const AdminMenusQuery = graphql(`
  query AdminMenus($limit: Int) {
    menus(limit: $limit) {
      items {
        id
        tenantId
        branchId
        name
        daysOfWeek
        startTime
        endTime
        active
        publishedAt
        createdAt
        updatedAt
        sections {
          id
          menuId
          name
          ordinal
          active
          products {
            id
            sectionId
            productId
            ordinal
            visible
            overridePriceCents
          }
        }
      }
    }
  }
`)

export const AdminMenuQuery = graphql(`
  query AdminMenu($id: ID!) {
    menu(id: $id) {
      id
      tenantId
      branchId
      name
      daysOfWeek
      startTime
      endTime
      active
      publishedAt
      createdAt
      updatedAt
      sections {
        id
        menuId
        name
        ordinal
        active
        products {
          id
          sectionId
          productId
          ordinal
          visible
          overridePriceCents
        }
      }
    }
  }
`)


// ── F9.4: escrituras de menús por el grafo (catalog-menus, tenant del JWT, RLS, IDOR-guard) ──
export const AdminCreateMenuMutation = graphql(`
  mutation AdminCreateMenu($input: MenuCreateInput!) {
    createMenu(input: $input) {
      id
      tenantId
      branchId
      name
      daysOfWeek
      startTime
      endTime
      active
      publishedAt
      createdAt
      updatedAt
      sections {
        id
        menuId
        name
        ordinal
        active
        products {
          id
          sectionId
          productId
          ordinal
          visible
          overridePriceCents
        }
      }
    }
  }
`)

export const AdminUpdateMenuMutation = graphql(`
  mutation AdminUpdateMenu($id: ID!, $input: MenuUpdateInput!) {
    updateMenu(id: $id, input: $input) {
      id
      tenantId
      branchId
      name
      daysOfWeek
      startTime
      endTime
      active
      publishedAt
      createdAt
      updatedAt
      sections {
        id
        menuId
        name
        ordinal
        active
        products {
          id
          sectionId
          productId
          ordinal
          visible
          overridePriceCents
        }
      }
    }
  }
`)

export const AdminDeleteMenuMutation = graphql(`
  mutation AdminDeleteMenu($id: ID!) {
    deleteMenu(id: $id)
  }
`)

export const AdminPublishMenuMutation = graphql(`
  mutation AdminPublishMenu($id: ID!) {
    publishMenu(id: $id) {
      id
      tenantId
      branchId
      name
      daysOfWeek
      startTime
      endTime
      active
      publishedAt
      createdAt
      updatedAt
      sections {
        id
        menuId
        name
        ordinal
        active
        products {
          id
          sectionId
          productId
          ordinal
          visible
          overridePriceCents
        }
      }
    }
  }
`)

export const AdminCreateMenuSectionMutation = graphql(`
  mutation AdminCreateMenuSection($menuId: ID!, $input: MenuSectionCreateInput!) {
    createMenuSection(menuId: $menuId, input: $input) {
      id
      menuId
      name
      ordinal
      active
      products {
        id
        sectionId
        productId
        ordinal
        visible
        overridePriceCents
      }
    }
  }
`)

export const AdminUpdateMenuSectionMutation = graphql(`
  mutation AdminUpdateMenuSection($menuId: ID!, $sectionId: ID!, $input: MenuSectionUpdateInput!) {
    updateMenuSection(menuId: $menuId, sectionId: $sectionId, input: $input) {
      id
      menuId
      name
      ordinal
      active
      products {
        id
        sectionId
        productId
        ordinal
        visible
        overridePriceCents
      }
    }
  }
`)

export const AdminDeleteMenuSectionMutation = graphql(`
  mutation AdminDeleteMenuSection($menuId: ID!, $sectionId: ID!) {
    deleteMenuSection(menuId: $menuId, sectionId: $sectionId)
  }
`)

export const AdminAddMenuProductMutation = graphql(`
  mutation AdminAddMenuProduct($menuId: ID!, $sectionId: ID!, $input: MenuProductAddInput!) {
    addMenuProduct(menuId: $menuId, sectionId: $sectionId, input: $input) {
      id
      sectionId
      productId
      ordinal
      visible
      overridePriceCents
    }
  }
`)

export const AdminRemoveMenuProductMutation = graphql(`
  mutation AdminRemoveMenuProduct($menuId: ID!, $sectionId: ID!, $menuProductId: ID!) {
    removeMenuProduct(menuId: $menuId, sectionId: $sectionId, menuProductId: $menuProductId)
  }
`)
